namespace TabAurous.Stock {
    export namespace StockSKUService {
        export const baseUrl = 'Stock/StockSKU';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/StockSKU/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>StockSKUService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
